import { Body } from '@sc/components/Typography'
import { Button, ButtonProps } from '@sc/components/Button'
import { IconBox } from '@sc/components/box/IconBox'
import { SelectList } from '@sc/components/SelectList'
import { TextGroup } from '@sc/components/TextGroup'
import { useSubscriptionActions } from 'hooks/useSubscriptionActions'
import { useTranslationPrefix } from 'hooks/useTranslationPrefix'

type SubscriptionButtonProps = ButtonProps & {
  children: string
  spaceId?: string
  isSubscribed?: boolean
}

export const SubscriptionButton = ({
  children,
  spaceId,
  isSubscribed = false,
  variant = 'secondary',
  ...props
}: SubscriptionButtonProps) => {
  const { redirecting, actions } = useSubscriptionActions(spaceId)

  const { t } = useTranslationPrefix('shared.billing')

  return (
    <Button
      variant={variant}
      onClick={isSubscribed ? actions.manageSubscription : actions.subscribe}
      disabled={redirecting}
      {...props}
    >
      {redirecting ? (
        t('redirecting')
      ) : (
        <>
          <Body>{children}</Body>
          <IconBox variant="small" name="arrowRight" />
        </>
      )}
    </Button>
  )
}

type SubscriptionSelectorProps = {
  isSubscribed?: boolean
  onValueChange: (value: 'free' | 'paid') => void
}

export const SubscriptionSelector = ({
  isSubscribed = false,
  onValueChange
}: SubscriptionSelectorProps) => {
  const { t } = useTranslationPrefix('shared.billing')

  return (
    <div>
      <TextGroup.Root variant="small" css={{ marginBottom: '$paddingUIXL' }}>
        <TextGroup.Primary>Please select your plan</TextGroup.Primary>
        <TextGroup.Secondary>You can upgrade whenever</TextGroup.Secondary>
      </TextGroup.Root>

      <SelectList.Root
        defaultValue={isSubscribed ? 'paid' : 'free'}
        onValueChange={onValueChange}
      >
        <SelectList.Item value="free" description={t('plans.free.description')}>
          {t('plans.free.name')}
        </SelectList.Item>

        <SelectList.Item value="paid" description={t('plans.paid.description')}>
          {t('plans.paid.name')}
        </SelectList.Item>
      </SelectList.Root>
    </div>
  )
}
